import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'

@Component({
  selector: 'dmmp-card',
  templateUrl: './card.component.html'
})
export class CardComponent implements OnInit {

  @Input() articlesItem
  @Output() page = new EventEmitter()

  constructor() { }

  ngOnInit(): void {
  }

}
